import {useI18n} from '@yandex-delivery/core/i18n'
import type {Optional} from '@yandex-delivery/types'

import type {DestinationPointDeliveryMethod, PickupStation} from 'src/shared/types'
import {SourcePointDeliveryMethod} from 'src/shared/types'

import {isTerminal} from '../utils/is-terminal'
import {isWarehouse} from '../utils/is-warehouse'

export function usePointTitle(
  point: Optional<PickupStation>,
  pointType: SourcePointDeliveryMethod.DropOffPoint | DestinationPointDeliveryMethod.PickUpPoint,
) {
  const t = useI18n()

  if (point?.is_post_office) {
    return point.name
  }

  if (pointType === SourcePointDeliveryMethod.DropOffPoint && isWarehouse(point?.type)) {
    return t('ndd.dropoff_points.warehouse.label', 'Сортировочный центр')
  }

  if (isTerminal(point?.type)) {
    return t('ndd.pickup_points.terminal_type', 'Постамат')
  }

  if (pointType === SourcePointDeliveryMethod.DropOffPoint) {
    return t('ndd.pickup_points.dropoff_point_type', 'Пункт приёма')
  }

  return t('ndd.pickup_points.pickup_point_type', 'Пункт выдачи')
}
